export default "Meta-Analyse zu Yoga und Schlafqualität bei Brustkrebs – Beleg für die wachsende Evidenz zu Schlaf als robustem Yoga-Outcome in der Onkologie."